import React, { useContext } from "react";
import { Redirect, Route, useLocation } from "react-router-dom";
import { getAllowedRoutes } from "../navigation/acl";
import { AclContext } from "../contexts/AclContext";
// import HeaderFooterContainer from "../v1/access-control/HeaderFooterContainer";
import Unauthorised from "./Unauthorised";
import { getRoutePaths } from "../navigation/routes";
import { UiVersion } from "../navigation/versioning";
import HeaderWrapper from "../v2/components/HeaderWrapper/HeaderWrapper";
import LoginPage from "../v2/components/LoginPage/LoginPage";

export function getUiVersionFromPath(path: string): UiVersion {
    if (/^\/v2\//g.test(path)) {
        return "v2";
    }
    return "v2";
}

// Helper function to convert v1 paths to v2 paths
function convertV1PathToV2(v1Path: string): string {
    if (v1Path.startsWith("/v1/")) {
        return v1Path.replace("/v1/", "/v2/");
    }
    // If path doesn't start with /v2/ and isn't /v1/, add /v2 prefix
    if (!v1Path.startsWith("/v2/") && v1Path !== "/") {
        return `/v2${v1Path}`;
    }
    return v1Path;
}

function AccessControlledRoute({ component, ...rest }: any) {
    const browserLocation = useLocation();
    const pathname = browserLocation.pathname;
    const aclContext = useContext(AclContext);
    const { path }: { path: string[] } = rest;

    if (
        pathname.startsWith("/v1/") ||
        (!pathname.startsWith("/v2/") && pathname !== "/")
    ) {
        const v2Path = convertV1PathToV2(pathname);
        return <Redirect to={v2Path} />;
    }

    // const requestedUiVersion: UiVersion = getUiVersionFromPath(pathname);
    const authUser = aclContext?.authUser;
    const allowedRoutes = getAllowedRoutes(authUser);
    const allowedRoutesForAllVersions: Set<string> = new Set();

    allowedRoutes.forEach((r) => {
        const otherVersionPaths = getRoutePaths(r);
        otherVersionPaths.forEach((p) => allowedRoutesForAllVersions.add(p));
    });

    const isAllowed = path.some((p) => allowedRoutesForAllVersions.has(p));

    if (!authUser?.user) {
        return <Route {...rest} component={LoginPage} />;
    }

    return (
        <Route
            {...rest}
            render={() =>
                isAllowed || path.includes("/unauthorised") ? (
                    <HeaderWrapper allowedRoutes={allowedRoutesForAllVersions}>
                        {component}
                    </HeaderWrapper>
                ) : (
                    <Unauthorised />
                )
            }
        />
    );
}

export default AccessControlledRoute;
